

const paketlemeItemDimensions =  [
    {
        id: 1,
        name: "Palet",
        dimensions: {
            en: 120,
            boy: 80,
            yukseklik: 0,
            agirlik: 0,
            sayisi: 0,
        }
    },
    {
        id:2,
        name: "Kutu",
        dimensions: {
            en: 0,
            boy: 0,
            yukseklik: 0,
            agirlik: 0,
            sayisi: 0,
        }
    },
    {
        id: 3,
        name: "Dökme",
        dimensions: {
            agirlik: 0,
        }
    },
    {
        id: 4,
        name: "Big Bag",
        dimensions: {
            agirlik: 0,
            sayisi: 0,
        }
    },
    {
        id: 5,
        name: "Varil Bidon",
        dimensions: {
            cap: 0,
            yukseklik: 0,
            agirlik: 0,
            sayisi: 0,
        }
    },
    {
        id: 6,
        name: "Teneke",
        dimensions: {
            en: 0,
            boy: 0,
            yukseklik: 0,
            agirlik: 0,
            sayisi: 0,
        }
    },
    {
        id: 7,
        name: "IBC",
        dimensions: {
            en: 0,
            boy: 0,
            yukseklik: 0,
            agirlik: 0,
            sayisi: 0,
        }
    },
    {
        id: 0,
        name: "Diğer",
        dimensions: {
            en: 0,
            boy: 0,
            yukseklik: 0,
            agirlik: 0,
            sayisi: 0,
        }
    },
]

export default paketlemeItemDimensions